import { c as _c } from "react/compiler-runtime";
import { Badge } from "@mantine/core";

/**
 * Presentational only — renders nothing if points is falsy/0/null, so it's
 * safe to drop into a card unconditionally without an extra guard at the
 * call site. Covers both states you'll want:
 *  - loyalty program inactive for this shop -> backend returns 0 -> nothing shown
 *  - this specific variant excluded via an admin override (points_per_unit: 0) -> nothing shown
 *
 * <EarnPointsBadge points={pointsMap[product.variant_id]} />              // product card
 * <EarnPointsBadge points={points} size="lg" />                           // product detail page
 */
export default function EarnPointsBadge(t0) {
  const $ = _c(13);
  const {
    points,
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? "text-[10px] lg:text-xs" : t1;
  const className = t2 === undefined ? "" : t2;
  if (!points || points <= 0) {
    return null;
  }
  const t3 = `flex items-center gap-1 border border-green-100 shadow-xs bg-green-50 px-1 lg:px-2 py-1 leading-none mb-2 rounded ${className}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-orange-400 text-xs"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="M12 1L9 9l-8 3l8 3l3 8l3-8l8-3l-8-3z" /></svg></span>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = `leading-tight font-medium text-green-900 tracking-wide inline-flex w-full gap-1  ${size} ${className}`;
  let t6;
  if ($[1] !== points) {
    t6 = points.toLocaleString();
    $[1] = points;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = points === 1 ? "" : "s";
  let t8;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = <div className={t5}>Earn {t6} Reward Point{t7}</div>;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="text-[8px] hidden lg:text-[10px] leading-none font-medium tracking-wider text-slate-600">Exclusive Store Credit</div>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t8) {
    t10 = <div className="flex flex-col">{t8}{t9}</div>;
    $[8] = t8;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t3) {
    t11 = <div className={t3}>{t4}{t10}</div>;
    $[10] = t10;
    $[11] = t3;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}